import { clearAuthLogin } from '@/redux/actions';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Stack from '@mui/material/Stack';
import Cookie from 'js-cookie';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Button } from 'components/button';
import { useDispatch, useLocale } from 'hooks';
import { useI18n } from 'locales';

function LogoutDialog({ isOpen, force, onClose }) {
  const dispatch = useDispatch();
  const locale = useLocale();
  const t = useI18n();
  const onClickLogoutHandler = useCallback(() => {
    dispatch(clearAuthLogin());
    Cookie.remove('authLoginInfo');
    location.href = `/giving/login?locale=${locale}`;
  }, [dispatch, locale]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogContent>
        <DialogContentText>
          {
            force ? t('The login session is expired. Please login again.') : t('Are you sure you want to logout?')
          }
        </DialogContentText>
        <Stack direction="row" justifyContent="center" >
          <DialogActions>
            {
              !force && (
                <Button onClick={onClose}>
                  {t('Cancel')}
                </Button>
              )
            }
            <Button onClick={onClickLogoutHandler}>
              {t('Logout')}
            </Button>
          </DialogActions>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

LogoutDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  force: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default LogoutDialog;
